import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-screen',
  templateUrl: './status-screen.component.html',
  styleUrls: ['./status-screen.component.css']
})
export class StatusScreenComponent implements OnInit {
  index: number = 0;
  constructor() { }

  ngOnInit() {
  }

  onTabChange(event) {
    this.index = event.index;
  }

  getCSSClassForPanel(index: number){
    if(index == this.index){
      return 'selected';
    }else{
      return 'unselected';
    }
  }
}
